import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import {provider} from '../../../../../../../../components/api/endpoints/provider'
import DataContext from "../../../../../../../../context/DataContext";
import { SelectOptionsDataProcessor } from "../../../../../../../../components/global/SelectOptionsDataProcessor";

export const useFieldOptionsMedicalDocumentsStatus = () =>{
    const { accessToken } = useContext(DataContext);
  
    const { isPending, error, data } = useQuery({
      queryKey: ["FieldOptions-Medical-Documents-Status"],
      queryFn: async () => {
  
        const response =
          provider.getMedicalDocumentStatusFieldOptions(accessToken);
        return await response;
      },
      select: (data) => SelectOptionsDataProcessor(data.results, "No Selection"),
    });
  
    return {
      isPending, 
      error, 
      data
    }
  
  }